import {
  Component,
  Output,
  EventEmitter,
  OnDestroy,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  Inject,
  Renderer2,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
  HostListener,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LayoutService } from "../services/layout.service";
import { Observable, Subscription } from "rxjs";
import { ConfigService } from "../services/config.service";
import { DOCUMENT } from "@angular/common";
import { CustomizerService } from "../services/customizer.service";
import { FormControl } from "@angular/forms";
import { LISTITEMS } from "../data/template-search";
import { Router } from "@angular/router";
import { AuthService } from "app/core/service/auth/auth.service";
import { ContentLibraryService } from "app/modules/content-library/_services/content-library.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  currentLang = "en";
  selectedLanguageText = "English";
  selectedLanguageFlag = "./assets/img/flags/us.png";
  toggleClass = "ft-maximize";
  placement = "bottom-right";
  logoUrl = "assets/mindset/logo.png";
  menuPosition = "Side";
  isSmallScreen = false;
  protected innerWidth: any;
  searchOpenClass = "";
  transparentBGClass = "";
  hideSidebar: boolean = true;
  rows = [];
  company = "";
  public isCollapsed = true;
  spinnrow = false;
  packageId = "";
  layoutSub: Subscription;
  configSub: Subscription;
  user$: Observable<any>;

  @ViewChild("search") searchElement: ElementRef;
  @ViewChildren("searchResults") searchResults: QueryList<any>;

  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  @Output()
  seachTextEmpty = new EventEmitter<boolean>();

  @Output() ctrlF: EventEmitter<boolean> = new EventEmitter();

  listItems = [];
  control = new FormControl();
  isMenuVisible = false;
  contentOwnerList = [];
  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible;
  }
  public config: any = {};
  public defaultId = "";

  public notifications: any[] = [];
  public totalNotificationCount: number = 0;

  private countSubscription: Subscription;
  private listSubscription: Subscription;
  constructor(
    public translate: TranslateService,
    private layoutService: LayoutService,
    private authservice: AuthService,
    private router: Router,
    private contentlibraryservice: ContentLibraryService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    public authserive: AuthService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : "en");
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;

    this.layoutSub = layoutService.toggleSidebar$.subscribe((isShow) => {
      this.hideSidebar = !isShow;
    });
  }

  changeDefaultRightHolder(id, company = "") {
    this.authserive.isSwitchingAccount = true;
    localStorage.setItem("company", company);
    this.defaultId = id;
    this.contentlibraryservice
      .switchAcccount({
        user_id: this.authserive.currentUserValue?.login_id,
        content_owner_id: id,
      })
      .subscribe((data: any) => {
        this.defaultId = "";
        window.location.href = '/dashboard/analytics';
      });
  }

  ngOnInit() {
    const data = localStorage.getItem("content_owner_array");
    if (data) {
      this.contentOwnerList = JSON.parse(data);
    }
    this.defaultId = this.authserive.currentUserValue?._id;
    this.user$ = this.authserive.currentUserSubject.asObservable();
    this.listItems = LISTITEMS;
    this.listItems = this.listItems.filter((li) => {
      return li.hasaccess.includes(this.authserive.currentUserValue?.type);
    });

    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }

    this.company = this.authserive.currentUserValue.company ? this.authserive.currentUserValue.company : ''
    this.getNotificationCount();
    this.getNotificationList();
  }

  getNotificationCount() {
    this.countSubscription = this.contentlibraryservice.getUnreadNotificationCount().subscribe((res: any) => {
      this.totalNotificationCount = res?.result || 0;
      this.cdr.markForCheck();
    });
  }

  getNotificationList() {
    this.listSubscription = this.contentlibraryservice.getTotalNotification().subscribe((res: any) => {
      this.notifications = res?.result || [];
      this.cdr.markForCheck();
    });
  }

  onNotificationHover(notification: any) {
    if (notification.read === 1) {
      notification.read = 2;

      // 2. Decrement your unread counter metric smoothly
      if (this.totalNotificationCount > 0) {
        this.totalNotificationCount--;
      }

     
      this.contentlibraryservice.notificationMarkAsRead(notification._id).subscribe({
        next: (response: any) => {
          this.getNotificationList()
          this.getNotificationCount();
        },
        error: (err) => {
          notification.read = 1;
          this.totalNotificationCount++;
          this.cdr.markForCheck();
        }
      });

      this.cdr.markForCheck();
    }
  }

  onDismiss(notification: any) {
    notification.isDismissing = true;

    this.contentlibraryservice.notificationMarkAsDismissed(notification._id).subscribe({
      next: (response: any) => {
        this.getNotificationList()
        this.getNotificationCount();
      },
      error: (err) => {
        notification.isDismissing = false;
        notification.read = 1;
        this.totalNotificationCount++;
        this.cdr.markForCheck();
      }
    });

    this.cdr.markForCheck();
  }

  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe(
      (templateConf) => {
        if (templateConf) {
          this.config = templateConf;
        }
        this.loadLayout();
        this.cdr.markForCheck();
      }
    );
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

    if (this.countSubscription) {
      this.countSubscription.unsubscribe();
    }
    if (this.listSubscription) {
      this.listSubscription.unsubscribe();
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }
  }

  loadLayout() {
    if (
      this.config.layout.menuPosition &&
      this.config.layout.menuPosition.toString().trim() != ""
    ) {
      this.menuPosition = this.config.layout.menuPosition;
    }

    if (this.config.layout.variant === "Light") {
      this.logoUrl = "assets/img/logo-dark.png";
    } else {
      this.logoUrl = "assets/mindset/logo.png";
    }

    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    } else {
      this.transparentBGClass = "";
    }
  }

  deletePackage(id) {
    this.packageId = id;
    this.contentlibraryservice.deletePackage(id).subscribe((data: any) => {
      this.cdr.markForCheck();
      this.getAllPackages();
      this.packageId = "";
    });
  }

  getAllPackages() {
    this.spinnrow = true;
    this.contentlibraryservice.getzipPackage().subscribe((data: any) => {
      this.spinnrow = false;
      this.cdr.markForCheck();
      this.rows = data.result;
    });
  }

  downloadPackage(id, file) {
    var a = document.createElement("a");
    a.href = file;
    a.download = `${file}.zip`;
    a.click();
  }

  onSearchKey(event: any) {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.add(
        "first-active-item"
      );
    }

    if (event.target.value === "") {
      this.seachTextEmpty.emit(true);
    } else {
      this.seachTextEmpty.emit(false);
    }
  }

  removeActiveClass() {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.remove(
        "first-active-item"
      );
    }
  }

  onEscEvent() {
    this.control.setValue("");
    this.searchOpenClass = "";
    this.seachTextEmpty.emit(true);
  }

  onEnter() {
    if (this.searchResults && this.searchResults.length > 0) {
      let url = this.searchResults.first.url;
      if (url && url != "") {
        this.control.setValue("");
        this.searchOpenClass = "";
        this.router.navigate([url]);
        this.seachTextEmpty.emit(true);
      }
    }
  }

  redirectTo(value) {
    this.router.navigate([value]);
    this.seachTextEmpty.emit(true);
  }

  ChangeLanguage(language: string) {
    this.translate.use(language);

    if (language === "en") {
      this.selectedLanguageText = "English";
      this.selectedLanguageFlag = "./assets/img/flags/us.png";
    } else if (language === "es") {
      this.selectedLanguageText = "Spanish";
      this.selectedLanguageFlag = "./assets/img/flags/es.png";
    } else if (language === "pt") {
      this.selectedLanguageText = "Portuguese";
      this.selectedLanguageFlag = "./assets/img/flags/pt.png";
    } else if (language === "de") {
      this.selectedLanguageText = "German";
      this.selectedLanguageFlag = "./assets/img/flags/de.png";
    }
  }

  ToggleClass() {
    if (this.toggleClass === "ft-maximize") {
      this.toggleClass = "ft-minimize";
    } else {
      this.toggleClass = "ft-maximize";
    }
  }

  toggleSearchOpenClass(display) {
    this.control.setValue("");
    if (display) {
      this.searchOpenClass = "open";
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 0);
    } else {
      this.searchOpenClass = "";
    }
    this.seachTextEmpty.emit(true);
  }

  // @HostListener('window:keydown', ['$event'])
  // onKeyDown(event: KeyboardEvent): void {
  //   if (event.keyCode === 70) {
  //     this.toggleSearchOpenClass(true);
  //   }
  // }

  toggleNotificationSidebar() {
    this.layoutService.toggleNotificationSidebar(true);
  }

  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }

  logout() {
    this.renderer.removeAttribute(this.document.body, "class");
    this.renderer.addClass(this.document.body, "layout-dark");
    this.renderer.addClass(this.document.body, "auth-page");

    this.authservice.logout();
  }
}
